module.exports = __webpack_public_path__ + "img/loginimage.d56944e4.png";